
const reducers = {
    default: (data, settings) => {
        if('getter' in settings) {
            return settings.getter(data);
        } else {
            return data;
        }
    },

    flatten: (data, settings, key, subKeys) => {
        if('storageKey' in settings) {
            subKeys.unshift(key);
        }

        return data;
    },

    list: (data, settings) => {
        return data;
    },

    syncList: (data, settings) => {
        return reducers.list(data, settings);
    }
}

function setReducedValue(key, subKeys, data, settings, target) {
    const mode = 'mode' in settings ? settings.mode : 'default';
    const storageKey = 'storageKey' in settings ? settings.storageKey : key;
    const storageKeyPathMapping = 'storageKeyPathMapping' in settings && storageKey in settings.storageKeyPathMapping
            ? settings.storageKeyPathMapping[storageKey].slice(0) 
            : [];

    let reducedValue = reducers.default(data, settings, key, subKeys);

    if(mode != 'default' && mode in reducers) {
        reducedValue = reducers[mode](reducedValue, settings, key, subKeys);
    }

    const keys = [ mode, storageKey ].concat(subKeys);

    if(storageKeyPathMapping.length) {
        let keyMappingMatchIndex = -1;

        for(let i = 0, j = 0; i < keys.length; i++) {
            if(storageKeyPathMapping[j] == keys[i]) {
                if(keyMappingMatchIndex == -1) {
                    keyMappingMatchIndex = i;
                }
                j++;
            } else if(keyMappingMatchIndex != -1) {
                keyMappingMatchIndex = -1;
                break;
            }
        }

        if(keyMappingMatchIndex != -1) {
            const deleteCount = keys.length - keyMappingMatchIndex;

            keys.splice(keyMappingMatchIndex, deleteCount);
            storageKeyPathMapping.splice(0, deleteCount);
        }
    }

    const lastKey = keys.pop();

    for(key of keys) {
        if(!(key in target)) {
            target[key] = {};
        }

        target = target[key];
    };

    if(storageKeyPathMapping.length) {
        for(key of storageKeyPathMapping) {
            if(key in reducedValue) {
                reducedValue = reducedValue[key];
            } else {
                break;
            }
        }
    }

    target[lastKey] = reducedValue;
}

export default function(store, storage, state, modules, includeRootState = true, trigger = null) {
    const reducedState = {};

    Object.keys(state).forEach(key => {
        const isNamespacedModule = `${key}/` in store._modulesNamespaceMap;
        const module = isNamespacedModule && key in modules ? modules[key] : null;
        const moduleKey = module ? key : '$root';

        if((!trigger || trigger.module == moduleKey) && ((isNamespacedModule && module) || (!isNamespacedModule && includeRootState))) {
            let settings = '$root' in modules ? modules.$root : {};
            let moduleSettingsDistinct = {};

            if(module) {
                if('settings' in module) {
                    settings = module.settings;
                } else {
                    settings = {};
                }
            }

            let persistSettings = 'persist' in settings ? settings.persist : {};

            if('persistDistinct' in settings) {
                if(module) {
                    moduleSettingsDistinct = settings.persistDistinct;
                } else if(key in settings.persistDistinct) {
                    persistSettings = Object.assign({}, persistSettings, settings.persistDistinct[key]);
                }
            }

            const targetStorage = 'storage' in persistSettings ? persistSettings.storage : null;
            const triggerMutations = 'mutations' in persistSettings ? persistSettings.mutations : null;

            if(module) {
                const moduleState = state[key];

                Object.keys(moduleState).forEach(subKey => {
                    const modulePersistSettings = subKey in moduleSettingsDistinct ? Object.assign({}, persistSettings, moduleSettingsDistinct[subKey]) : persistSettings;
                    const moduleTargetStorage = 'storage' in modulePersistSettings ? modulePersistSettings.storage : null;
                    const moduleTriggerMutations = 'mutations' in modulePersistSettings ? modulePersistSettings.mutations : null;
                    const subKeys = 'useStateKey' in modulePersistSettings && !modulePersistSettings.useStateKey ? [] : [ subKey ];
                    
                    if(!trigger || !moduleTriggerMutations || moduleTriggerMutations.includes(trigger.mutation)) {
                        if(moduleTargetStorage == storage) {
                            setReducedValue(key, subKeys, moduleState[subKey], modulePersistSettings, reducedState);
                        } else if(moduleTargetStorage !== false && targetStorage == storage) {
                            setReducedValue(key, subKeys, moduleState[subKey], persistSettings, reducedState);
                        }
                    }
                });
            } else if((!trigger || !triggerMutations || triggerMutations.includes(trigger.mutation)) && (targetStorage === null || targetStorage == storage)) {
                setReducedValue(key, [], state[key], persistSettings, reducedState);
            }
        }
    });

    return reducedState;
}